const osBtns = document.querySelectorAll('[data-os-btn]')
const osTextBlocks = document.querySelectorAll('[data-os-text]')

osBtns.forEach(btn => btn.addEventListener('click', selectOS))

function selectOS() {
  osBtns.forEach(btn => btn.classList.remove('active'))

  const activeOSName = this.getAttribute('data-os-btn')
  osTextBlocks.forEach(el => {
    const osName = el.getAttribute('data-os-text')

    if (osName === activeOSName) {
      el.classList.add('active')
    } else {
      el.classList.remove('active')
    }
  })

  this.classList.add('active')
}
